import { Injectable, TemplateRef } from '@angular/core';

/**
 * DO NOT FORGET TO ADD
 * <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
 * TO ANY HTML PAGE OR ROOT APP HTML TO ENJOY TOASTER
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: any[] = [];
    display: boolean = false;
    spin(){
        this.display = true;
    }

    hide(){
        this.display = false;
    }
}
